import React from "react";
import "./Category.css";
import Ccarpet from "../assets/images/Ccarpet.png";
import Clifestyle from "../assets/images/Clifestyle.png";
import cRug from "../assets/images/cRug.png";
import chometextile from "../assets/images/chometextile.png";
import { Link } from "react-router-dom"; //Link

function Category() {
  return (
    <>
      <div className="category_outer_main">
        <div className="container-fluid">
         
            <div className="category_outer_box">

              <div className="category_item">
               <Link to="/products" className="category_item_outer">  
                  <img src={cRug} alt="" />
                  <div className="category_text">
                    <Link to="/products">Carpets & Rugs </Link>
                  </div>
                </Link>
              </div>

              <div className="category_item">
                <Link to="/products" className="category_item_outer">  
                  <img src={chometextile} alt="" />
                  <div className="category_text">
                    <Link to="/products">Home Textiles </Link>
                  </div>
                 </Link>
              </div>

              <div className="category_item">
               <Link to="/products" className="category_item_outer">  
                  <img src={Clifestyle} alt="" />
                  <div className="category_text">
                    <Link to="/products">Lifestyle Apparel </Link>
                  </div>
                </Link>
              </div>
              
            </div>
          
        </div>
      </div>
    </>
  );
}

export default Category;
